class PasswordVisibility {
    Init() {
        var inst = this;
        $('.input-icon').click(function (event) {
            event.preventDefault();
            inst.SetPasswordVisibility($(this));
        });
    }


    SetPasswordVisibility(e) {
        var toggleIcon = $(e).children('img');
        const input = $(e).parent().find('input[type="password"],input[type="text"]');
        if (input.attr("type") === "password") {
            input.attr("type", "text");
            toggleIcon.attr("src", "/../../../Images/pw-hide-icon.svg");
        } else {
            input.attr("type", "password");
            toggleIcon.attr("src", "/../../../Images/pw-show-icon.svg");
        }
    }
}
$(document).ready(function () {
    var passwordVisibility = new PasswordVisibility();
    passwordVisibility.Init();
});